import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FinalStyles from "./FinalSubmission.module.css";
import axios from "axios";
import ConfettiPopup from "./ConfettiPopup";


const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const FinalSubmission = () => {
  const [title, setTitle] = useState("");
  const [poemType, setPoemType] = useState("regulated");
  const [poem, setPoem] = useState("");
  const [message, setMessage] = useState("");
  const [isGuest, setIsGuest] = useState(false);
  const navigate = useNavigate();
  const [previousSubmissions, setPreviousSubmissions] = useState([]);
  const [showPreviousSubmissions, setShowPreviousSubmissions] = useState(false);
  const [loadingPrevious, setLoadingPrevious] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setIsGuest(true);
      setMessage("Only logged-in users can make final submissions to the Newman Prize since we don't have your details.");
      return;
    }

    if (!title || !poem || !poemType) {
      setMessage("Please fill in all fields before submitting.");
      return;
    }

    try {
      const token = localStorage.getItem("token"); // Assuming token is stored in localStorage
      const response = await axios.post(
        `${API_URL}/final-submission`,
        {
          title,
          poem_type: poemType,
          poem,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setShowConfetti(true);
      setMessage("");
      setTitle("");
      setPoem("");
      setPoemType("");
    } catch (error) {
      console.error("Error submitting poem:", error);
      setMessage("An error occurred while submitting your poem. Please try again.");
    }
  };

  const redirectToLogin = () => {
    navigate("/"); // redirect to home page
  };

  const fetchPreviousFinalSubmissions = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    setMessage("Please log in to view your previous final submissions.");
    return;
  }

  try {
    setLoadingPrevious(true);

    const response = await axios.get(`${API_URL}/user/final-submissions`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setPreviousSubmissions(response.data);
    setShowPreviousSubmissions(true);
  } catch (error) {
    console.error("Error fetching previous final submissions:", error);
    setMessage("Unable to load previous final submissions.");
  } finally {
    setLoadingPrevious(false);
  }
};

  return (
    <div className={FinalStyles.container}>

      <div style={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "8px", marginTop: "-8px" }}>
        <button
          onClick={fetchPreviousFinalSubmissions}
          style={{
            backgroundColor: "#4A90E2",
            color: "white",
            border: "none",
            padding: "12px 28px",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "1rem",
            fontWeight: "600",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
          }}
        >
          View Previous Submissions
        </button>
      </div>
      {showConfetti && (
        <ConfettiPopup
          message="Submission successful! Your poem has been submitted for the final Jinshi assessment."
          onClose={() => setShowConfetti(false)}
        />
      )}
      <h1 className={FinalStyles.heading}>Final Submission</h1>
      <p className={FinalStyles.text}>
        Here, you are submitting your work for the International Newman Prize for English Jueju Competition!. Have your work evaluated and recognized.
      </p>
      <div className={FinalStyles.form}>
        <label className={FinalStyles.label}>Title of the Poem:</label>
        <input
          type="text"
          className={FinalStyles.input}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Enter the title of your poem"
        />
        <label className={FinalStyles.label}>Type of Poem:</label>
        <select
          className={FinalStyles.select}
          value={poemType}
          onChange={(e) => setPoemType(e.target.value)}
          required
        >
          <option value="" disabled>Please select an option</option>
          <option value="regulated">Regulated</option>
          <option value="unregulated">Unregulated</option>
        </select>
        <label className={FinalStyles.label}>Poem:</label>
        <textarea
          className={FinalStyles.textarea}
          value={poem}
          onChange={(e) => setPoem(e.target.value)}
          placeholder={"Type your poem here... \n\n (Note: Please remove all punctuation from your jueju including apostrophes!)"}
        />
        <button className={FinalStyles.submitButton} onClick={handleSubmit}>
          Submit
        </button>
        {message && <p className={FinalStyles.message}>{message}</p>}
        {isGuest && (
          <button className={FinalStyles.loginButton} onClick={redirectToLogin}>
            Login/Signup
          </button>
        )}
      </div>

      {showPreviousSubmissions && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            padding: "20px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              width: "100%",
              maxWidth: "700px",
              maxHeight: "80vh",
              overflowY: "auto",
              borderRadius: "16px",
              padding: "24px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
              position: "relative",
              textAlign: "center",
            }}
          >
            <button
              onClick={() => setShowPreviousSubmissions(false)}
              style={{
                position: "absolute",
                top: "14px",
                right: "16px",
                background: "none",
                border: "none",
                fontSize: "28px",
                cursor: "pointer",
                color: "#999",
                fontWeight: "bold",
              }}
            >
              ×
            </button>

            <h2
              style={{
                marginBottom: "20px",
                color: "#4a3b2f",
                fontSize: "2rem",
                fontWeight: "700",
              }}
            >
              Your Final Submissions
            </h2>

            {loadingPrevious ? (
              <p style={{ color: "#4a3b2f" }}>Loading...</p>
            ) : previousSubmissions.length === 0 ? (
              <p style={{ color: "#4a3b2f" }}>No previous final submissions found.</p>
            ) : (
              previousSubmissions.map((submission) => (
                <div
                  key={submission._id}
                  style={{
                    backgroundColor: "#f4efe3",
                    padding: "18px",
                    borderRadius: "10px",
                    marginBottom: "16px",
                    textAlign: "center",
                  }}
                >
                  <p><strong>Title:</strong> {submission.title || "Untitled"}</p>
                  <p><strong>Poem Type:</strong> {submission.poem_type || "Unknown"}</p>
                  <p>
                    <strong>Submitted At:</strong>{" "}
                    {submission.submitted_at
                      ? new Date(submission.submitted_at).toLocaleString()
                      : "N/A"}
                  </p>

                  <p style={{ marginTop: "10px" }}><strong>Poem:</strong></p>
                  <div
                    style={{
                      whiteSpace: "pre-wrap",
                      lineHeight: "1.8",
                      color: "#333",
                    }}
                  >
                    {submission.poem || "No poem content"}
                  </div>

                  {submission.feedback && submission.feedback.trim() !== "" && (
                    <p style={{ marginTop: "12px" }}>
                      <strong>Feedback:</strong> {submission.feedback}
                    </p>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FinalSubmission;


